<script setup>
    import { ref} from 'vue';
    
    import {useMindArchives} from '../store/mindarchives';
    import router from '@/router';

    import '../assets/css/main.css';

    document.body.style.backgroundColor = "black";

    let loadingPrompt = ref("");
    let isLoading = ref(false);
    const mindArchives = useMindArchives(); 

    async function getArchive() {
        
        if(!mindArchives.archiveData.id)
            return;

        isLoading.value = true;
        loadingPrompt.value = "Fetching archive";
        try{
            await mindArchives.fetchArchive();  

            if(mindArchives.archiveData){
                if(mindArchives.archiveData.content){
                    isLoading.value = false;
                    router.push({path:'archives/' + mindArchives.archiveData.id});
                }
            }else{
                isLoading.value = false;
            }
        }catch(ex){
            isLoading.value = false;
            loadingPrompt.value = ex;
        }

    }

</script>

<template>
    <div id="contentapp">
        <div class="logoct">
            <img src="../assets/mnta.png" height="50"/>
        </div>

        404

        <div id="prompt">
            {{ loadingPrompt }}
            <div v-if="isLoading">
            </div>
            <div v-else>
                <div id="input-form">
                    <input class="input-text-wp" type="text" v-model="mindArchives.archiveData.id"/>
                    <button v-on:click="getArchive" class="submit-btn-wp">
                        &#x1F50E;&#xFE0E;
                    </button>

                </div>
            </div>

            <div id="hint">
                opkklu pu lclyf dypapunz
            </div>
        </div>

    </div>
    
</template>

<style scoped>


#contentapp{
    background-color: black;
    text-align: center;
    margin: 0 0 0 0;
    padding-top: 10px;
    width: 100%;

    position: absolute;
    
    height: 100%;
    color: #fff;
}

.logoct{
    width: 70px;
    height: 70px;
    margin-top: 30px;
    margin-bottom: 10px;
    margin-left: auto;
    margin-right: auto;
}

.submit-btn-wp{
    background-color: transparent;
    cursor: pointer;
    box-sizing: border-box;
    width: 50px;
    overflow: visible; 
    color: rgba(226, 226, 226,0.3);
    font-size: 20px;
    margin-left: 10px;
    border-radius: 5px;
    height: 40px;
    float: right;
}

.input-text-wp{
    font-size: 25px;
    text-align: center;
    border: none;
    border-bottom: 1px solid rgba(226, 226, 226,0.3);
    border-radius: 0px;
    width: 240px;
    box-sizing: border-box;
    background-color: transparent;
    color: rgba(226, 226, 226,0.3);
    font-family: 'Courier New', Courier, monospace;
    height: 35px;
}

#input-form{
    box-sizing: border-box;
    vertical-align: top;
    width: 300px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    padding-left: auto;
    padding-right: auto;
}

#prompt{
    margin-top: 30px;
}

#hint{
    position: absolute;
    bottom: 0;
    left: 43%;
    text-align: center;
    color: rgba(255,255,255,0.3);
}

</style>